import { useLiveData, useService } from '@toeverything/infra';

import { AppSidebarService } from '../../services/app-sidebar';
import { navHeaderStyle } from '../index.css';
import { PabblyLogo } from './pabbly-logo';
import { pabblyLogo } from './pabbly-logo.css';
import { SidebarSwitch } from './sidebar-switch';

export const SidebarHeader = () => {
  const appSidebarService = useService(AppSidebarService).sidebar;
  const open = useLiveData(appSidebarService.open$);

  return (
    <div className={navHeaderStyle} data-open={open}>
      <SidebarSwitch show={open} />
      <PabblyLogo className={pabblyLogo} />
    </div>
  );
};

export * from './sidebar-switch';
